export default (pageFolder) => ({
  nodeId: pageFolder.pageFolderId,
  nodeType: pageFolder.pageFolderType,
  streams: pageFolder.dataSourceConfigurations,
  ...pageFolder,
});
